module.exports = __webpack_public_path__ + "static/img/logo.1a2f693d.png";